module.exports = __webpack_public_path__ + "img/logo-propel-light.821e4ca.svg";